// Live Portrait Guestbook promo card (src/_includes/live-portrait-popup.html).
// Shows once the visitor has been on the page for a while or scrolled a
// fair way down, whichever comes first. It appears at most once a week per
// visitor: as soon as it shows, it is hidden on every other page for 7 days,
// even if ignored. Closing it hides it for 30 days; clicking through for 60.
// localStorage can throw (private mode, blocked storage) — in that case the
// card just shows as normal.

import { onReady } from "#public/utils/on-ready.js";

const STORAGE_KEY = "lpPromoHiddenUntil";
const SHOW_AFTER_MS = 12000;
const SHOW_AFTER_SCROLL = 0.4;
const DAY_MS = 24 * 60 * 60 * 1000;
const HIDE_DAYS_ONCE_SHOWN = 7;
const HIDE_DAYS_ON_CLOSE = 30;
const HIDE_DAYS_ON_CLICK = 60;

const readHiddenUntil = () => {
  try {
    return Number(localStorage.getItem(STORAGE_KEY)) || 0;
  } catch {
    return 0;
  }
};

const hideForDays = (days) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + days * DAY_MS));
  } catch {
    // Storage unavailable — nothing to remember.
  }
};

const scrolledFraction = () => {
  const scrollable =
    document.documentElement.scrollHeight - window.innerHeight;
  return scrollable > 0 ? window.scrollY / scrollable : 0;
};

const initPromo = (card) => {
  let shown = false;
  let timer = 0;

  const onScroll = () => {
    if (scrolledFraction() >= SHOW_AFTER_SCROLL) show();
  };

  const show = () => {
    if (shown) return;
    shown = true;
    clearTimeout(timer);
    hideForDays(HIDE_DAYS_ONCE_SHOWN);
    window.removeEventListener("scroll", onScroll);
    card.hidden = false;
    requestAnimationFrame(() => card.classList.add("is-visible"));
  };

  const close = () => {
    hideForDays(HIDE_DAYS_ON_CLOSE);
    card.classList.remove("is-visible");
    card.hidden = true;
  };

  card
    .querySelector("[data-lp-promo-close]")
    ?.addEventListener("click", close);
  for (const link of card.querySelectorAll("[data-lp-promo-cta]")) {
    link.addEventListener("click", () => hideForDays(HIDE_DAYS_ON_CLICK));
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && shown && !card.hidden) close();
  });

  timer = setTimeout(show, SHOW_AFTER_MS);
  window.addEventListener("scroll", onScroll, { passive: true });
};

onReady(() => {
  const card = document.querySelector("[data-lp-promo]");
  if (!card || readHiddenUntil() > Date.now()) return;
  initPromo(card);
});
